import { EventBus } from 'pdfjs-dist/lib/web/ui_utils';
export default new EventBus();